import React from 'react';
import { List, Datagrid, TextField, CreateButton, TopToolbar } from 'react-admin';

const ContentTypeListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export const ContentTypeList = () => (
  <List 
    actions={<ContentTypeListActions />}
    empty={
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ marginBottom: '20px' }}>No content types</div>
        <CreateButton />
      </div>
    }
  >
    <Datagrid>
      <TextField source="name" />
      <TextField source="display_name" />
      <TextField source="description" />
    </Datagrid>
  </List>
);

